import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xdGdqaXowMCB7CiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoNy41cmVtLCAxLjA1cmVtKSBzY2FsZSgxKTsKfQ';
export var adjustedLabelTransform = '_1tgjiz00';